import React, { useEffect, useState, useRef } from "react";
import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../../auth/auth";
import GradingScoresChart from "./Grading Graph/Graph";
import { getAverageGradings } from "../../../api/apiCall";
import { gradingsContainer } from "./style";

const Gradings = () => {
  const { state } = useAuth();
  const [searchParams] = useSearchParams();
  const [grades, setGrades] = useState([]);
  const hasFetched = useRef(false);

  const getGradings = async () => {
    try {
      const response = await getAverageGradings(
        state.user?.token,
        searchParams.get("workerId")
      );
      setGrades(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!hasFetched.current) {
      getGradings();
      hasFetched.current = true;
    }
  }, []);

  return (
    <Box sx={gradingsContainer}>
      <Box display="flex" justifyContent="space-between" mb={2}>
        <h2>Objective Worker Scoring</h2>
      </Box>
      <Box display="flex" flexDirection="row" justifyContent={"center"} ml={15}>
        <GradingScoresChart grades={grades} getGradings={getGradings} />
      </Box>
    </Box>
  );
};

export default Gradings;
